const Banner = () => {
  // const slides = [
  //   {
  //     image: Slider1,
  //   },
  //   {
  //     image: Slider2,
  //   },
  //   {
  //     title: "Från Planering Till Färdig Renovering",
  //     text: "Vi hjälper dig genom hela processen för ett bekymmersfritt projekt.",
  //     image: Slider3,
  //   },
  // ];

  return (
    <>
      <div class="banner-img"></div>
      {/* <div
        id="carouselExampleFade"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div class="banner-card">
          <div class="banner-card-content">
            <h1 className="text-white">
              Vi Hjälper Dig Med Din Lägenhet, Rådhus, Villa Renovering
            </h1>
            <p className="text-white">
              Vi är ett utmärkt alternativ för dig som behöver hjälp med en
              renovering i Norrort!
            </p>
            <Link to="/renovation" className="reg-btn">
              Gratis offert
            </Link>
          </div>
        </div>
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={slide.image}
                className="d-block w-100 rounded-3"
                alt={`Slide ${index + 1}`}
              />
              <div className="carousel-caption d-none d-md-block">
                <h5>{slide.title}</h5>
                <p>{slide.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </>
  );
};

export default Banner;
